import React, { useState, useRef, useEffect } from "react";

//Import Mui
import {
  Box,
  Button,
  CardContent,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from "@mui/material";
import MuiTextField from "../../controls/MuiTextField";
import MuiTableSearch from "../../controls/MuiTableSearch";
import Alert from "../../controls/MuiSnackbarAlert";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

//Import AntD
import { Modal } from "antd";

//Import Redux
import { useDispatch, useSelector } from "react-redux";

//Import Reduxtoolkit
import { unwrapResult } from "@reduxjs/toolkit";

//Import from loginSlice.js
import {
  getSignInUser,
  getSignInUserFromServer,
} from "../../registration/signin/loginSlice";

//Import from customerSlice.js
import {
  addCustomerToServer,
  deleteCustomerFromServer,
  getCustomersCountFromServer,
  getCustomersFromServer,
  getCustomersFromServerByPagination,
  updateCustomerInServer,
} from "./customerSlice";

//Import CSS
import "./customer.css";

const Customer = () => {
  const { confirm } = Modal;
  const dispatch = useDispatch();
  const signinUser = useSelector(getSignInUser);

  //useState
  const [loginUser, setLoginUser] = useState(signinUser);
  const [showFieldsContainer, setShowFieldsContainer] = useState(false);
  const [customerId, setCustomerId] = useState(0);
  const [customerCode, setCustomerCode] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerPlace, setCustomerPlace] = useState("");
  const [customerContactNo, setCustomerContactNo] = useState("");
  const [openingBalance, setOpeningBalance] = useState("");
  const [buttonSave, setButtonSave] = useState("Save");
  const [customersList, setCustomersList] = useState([]);
  const [originalCustomersList, setOriginalCustomersList] = useState([]);
  const [customersCount, setCustomersCount] = useState(0);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    severity: "",
  });
  // const [preventTableDataRendering, setPreventTableDataRendering] =
  //   useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  //End useState

  //useRef
  const customerCodeRef = useRef(null);
  const customerNameRef = useRef(null);
  const customerPlaceRef = useRef(null);
  const customerContactNoRef = useRef(null);
  const openingBalanceRef = useRef(null);
  const saveRef = useState(null);
  const cancelRef = useState(null);
  const clearRef = useState(null);
  //End useRef

  const fetchDatasByPagination = async (pageNo, rowSize) => {
    try {
      const result = await dispatch(
        getCustomersFromServerByPagination({ pageNo, rowSize })
      );
      const unwrappedResult = unwrapResult(result);
      if (unwrappedResult.data.length === 0) {
        setNotify({
          isOpen: true,
          message: unwrappedResult.message,
          severity: "warning",
        });
      }
      if (Array.isArray(unwrappedResult.data))
        setCustomersList(unwrappedResult.data);
    } catch (err) {
      console.log({ ErrorOccured: err });
      setNotify({
        isOpen: true,
        message: err.message,
        severity: "error",
      });
    }
  };

  //useEffect
  useEffect(() => {
    if (loginUser === null) {
      dispatch(getSignInUserFromServer())
        .then(unwrapResult)
        .then((result) => {
          setLoginUser(result.data);
        });
    }

    const fetchDatas = async () => {
      try {
        const customersListResult = await dispatch(getCustomersFromServer());
        const unwrappedResult = unwrapResult(customersListResult);
        if (unwrappedResult.data.length > 0) {
          setOriginalCustomersList(unwrappedResult.data);
        }

        const customersCountResult = await dispatch(
          getCustomersCountFromServer()
        );
        const unwrappedCustomersCountResult =
          unwrapResult(customersCountResult);
        unwrappedCustomersCountResult.data[0].CustomersCount === undefined
          ? setCustomerCode(0)
          : setCustomersCount(
              unwrappedCustomersCountResult.data[0].CustomersCount
            );
      } catch (err) {
        console.log({ ErrorOccured: err });
        setNotify({
          isOpen: true,
          message: err.message,
          severity: "error",
        });
      }
    };

    setTimeout(() => {
      fetchDatas();
    }, 1000);
  }, []);

  useEffect(() => {
    fetchDatasByPagination(page + 1, rowsPerPage);
  }, [page, rowsPerPage]);

  //End useEffect

  const handleAdd = (e) => {
    e.preventDefault();
    setShowFieldsContainer(true);
    resetfields();
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleSave = (e) => {
    e.preventDefault();
    validate();
  };

  const validate = async () => {
    let trimmedCustomerCode = customerCode.trim();
    let trimmedCustomerName = customerName.trim();
    let trimmedPlace = customerPlace.trim();
    let trimmedContactNo = customerContactNo.trim();

    if (trimmedCustomerCode === "") {
      setNotify({
        isOpen: true,
        message: "Customer Code is required",
        severity: "warning",
      });
      customerCodeRef.current.focus();
      return;
    } else if (trimmedCustomerName === "") {
      setNotify({
        isOpen: true,
        message: "Customer Name is required",
        severity: "warning",
      });
      customerNameRef.current.focus();
      return;
    } else if (trimmedPlace === "") {
      setNotify({
        isOpen: true,
        message: "Place is required",
        severity: "warning",
      });
      customerPlaceRef.current.focus();
      return;
    } else if (openingBalance === "") {
      setNotify({
        isOpen: true,
        message: "Opening Balance is required",
        severity: "warning",
      });
      openingBalanceRef.current.focus();
      return;
    } else {
      if (buttonSave === "Save") {
        let newCustomer = {
          customerCode: trimmedCustomerCode,
          customerName: trimmedCustomerName,
          customerPlace: trimmedPlace,
          customerContactNo: trimmedContactNo,
          openingBalance: parseFloat(openingBalance).toFixed(2),
          loginUser,
        };
        await dispatch(addCustomerToServer(newCustomer))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else if (result.flag === 2) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "warning",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        await dispatch(getCustomersCountFromServer())
          .then(unwrapResult)
          .then((result) => {
            setCustomersCount(result.data[0].CustomersCount);
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });
      } else {
        let updatedCustomer = {
          customerCode: trimmedCustomerCode,
          customerName: trimmedCustomerName,
          customerPlace: trimmedPlace,
          customerContactNo: trimmedContactNo,
          openingBalance: parseFloat(openingBalance).toFixed(2),
          loginUser,
        };
        await dispatch(
          updateCustomerInServer({ ...updatedCustomer, customerId })
        )
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else if (result.flag === 2) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "warning",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });
      }
      // await dispatch(getCustomersFromServer())
      //   .then(unwrapResult)
      //   .then((result) => {
      //     if (result.data.length > 0) {
      //       setCustomersList(result.data);
      //     }
      //   })
      //   .catch((err) => console.log({ objError: err }));
      await fetchDatasByPagination(page + 1, rowsPerPage);
      resetfields();
      customerCodeRef.current.focus();
      setButtonSave("Save");
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    resetfields();
    setShowFieldsContainer(false);
    setButtonSave("Save");
  };

  const handleClear = (e) => {
    e.preventDefault();
    resetfields();
    customerCodeRef.current.focus();
  };

  const resetfields = () => {
    setCustomerId(0);
    setCustomerCode("");
    setCustomerName("");
    setCustomerPlace("");
    setCustomerContactNo("");
    setOpeningBalance("");
  };

  const columns = [
    { id: "Action", label: "Action", minWidth: 100 },
    {
      id: "Id",
      label: "Id",
      minWidth: 100,
    },
    { id: "CUCode", label: "Code", minWidth: 170 },
    { id: "CUName", label: "Name", minWidth: 170 },
    { id: "Place", label: "Place", minWidth: 170 },
    { id: "ContactNo", label: "Contact No", minWidth: 170 },
    {
      id: "OpeningBalance",
      label: "Opening Balance",
      align: "right",
      minWidth: 170,
    },
  ];

  const handleChangePage = (event, newPage) => {
    event.preventDefault();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(event.target.value);
    setPage(0);
  };

  const handleEdit = (customer) => {
    setCustomerId(customer.Id);
    setCustomerCode(customer.CUCode);
    setCustomerName(customer.CUName);
    setCustomerPlace(customer.Place);
    setCustomerContactNo(customer.ContactNo);
    setOpeningBalance(customer.OpeningBalance);
    showFieldsContainer
      ? customerCodeRef.current.focus()
      : setShowFieldsContainer(true);
    setButtonSave("Update");
  };

  const handleUpdate = () => {
    validate();
  };

  const handleDelete = async (customerid) => {
    resetfields();
    setButtonSave("Save");
    confirm({
      title: "Are you sure to delete this customer?",
      // content: "Some descriptions",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      async onOk() {
        await dispatch(deleteCustomerFromServer({ customerid, loginUser }))
          .then(unwrapResult)
          .then((result) => {
            if (result.flag === 1) {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "success",
              });
            } else {
              setNotify({
                isOpen: true,
                message: result.message,
                severity: "error",
              });
            }
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        await dispatch(getCustomersCountFromServer())
          .then(unwrapResult)
          .then((result) => {
            setCustomersCount(result.data[0].CustomersCount);
          })
          .catch((err) => {
            console.log({ ErrorOccured: err });
            setNotify({
              isOpen: true,
              message: err.message,
              severity: "error",
            });
          });

        // console.log(page);
        let currentPage = parseInt(page + 1);
        // console.log(currentPage);
        // console.log(rowsPerPage);
        // console.log(gendersList.length);
        const newTotalRecords = customersCount - 1;
        // console.log(newTotalRecords);
        const totalPages = Math.ceil(newTotalRecords / rowsPerPage); // rowcount
        // console.log(totalPages);
        if (currentPage > totalPages) {
          setPage(Math.max(totalPages - 1, 0)); // Ensures the page is at least 0
          await fetchDatasByPagination(page, rowsPerPage);
        } else {
          await fetchDatasByPagination(page + 1, rowsPerPage);
        }
        showFieldsContainer
          ? customerCodeRef.current.focus()
          : setShowFieldsContainer(false);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const handleSearch = (searchedVal) => {
    if (!searchedVal) {
      fetchDatasByPagination(page + 1, rowsPerPage);
    } else {
      const filteredRows = originalCustomersList.filter((customer) => {
        return (
          customer.CUCode.toLowerCase().includes(searchedVal.toLowerCase()) ||
          customer.CUName.toLowerCase().includes(searchedVal.toLowerCase())
        );
      });
      setCustomersList(filteredRows);
    }
  };

  return (
    <>
      <Box className="customerboxcontainer">
        <Alert notify={notify} setNotify={setNotify} />
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: "5px" }}
        >
          <Grid item>
            <Button
              variant="outlined"
              size="small"
              onClick={handleAdd}
              sx={{ mb: "5px" }}
            >
              Add
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={handleRefresh}
              sx={{ mb: "5px", ml: "10px" }}
            >
              Refresh
            </Button>
          </Grid>
          <Grid
            item
            sx={{ display: "flex", alignItems: "center", mt: "-13px" }}
          >
            <MuiTableSearch
              placeholder="Search Customer"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </Grid>
        </Grid>

        {showFieldsContainer ? (
          <Paper className="paper" elevation={2} sx={{ p: 2 }}>
            <h6>Add Customer</h6>
            <Divider />
            <CardContent>
              <Grid container spacing={2} className="gridContainer">
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="customercode"
                    label="Customer Code *"
                    onChange={(e) => {
                      setCustomerCode(e.target.value);
                    }}
                    value={customerCode}
                    inputRef={customerCodeRef}
                    autoComplete="off"
                    autoFocus
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="customername"
                    label="Customer Name *"
                    onChange={(e) => {
                      setCustomerName(e.target.value);
                    }}
                    value={customerName}
                    inputRef={customerNameRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        customerCodeRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="place"
                    label="Place *"
                    onChange={(e) => {
                      setCustomerPlace(e.target.value);
                    }}
                    value={customerPlace}
                    inputRef={customerPlaceRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        customerNameRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    id="contactno"
                    label="Contact No"
                    onChange={(e) => {
                      setCustomerContactNo(e.target.value);
                    }}
                    value={customerContactNo}
                    inputRef={customerContactNoRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        customerPlaceRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <MuiTextField
                    type="number"
                    id="openingbalance"
                    label="Opening Balance *"
                    onChange={(e) => {
                      //not allow to enter negative values - /^\d*\.?\d*$/
                      //not allow to enter negative values & allow only 2 digits after decimal - /^\d*\.?\d{0,2}$/
                      const newValue = e.target.value;
                      if (!newValue || newValue.match(/^\d*\.?\d{0,2}$/)) {
                        setOpeningBalance(parseFloat(newValue));
                      }
                    }}
                    value={isNaN(openingBalance) ? "" : openingBalance}
                    inputRef={openingBalanceRef}
                    autoComplete="off"
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        customerContactNoRef.current.focus();
                    }}
                  />
                </Grid>
                <Grid item xs={6} sm={3} md={1}>
                  {buttonSave === "Save" ? (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnsave"
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          openingBalanceRef.current.focus();
                      }}
                      onClick={handleSave}
                    >
                      Save
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      size="small"
                      className="btnupdate"
                      ref={saveRef}
                      onKeyDown={(e) => {
                        if (e.key.toLowerCase() === "home")
                          openingBalanceRef.current.focus();
                      }}
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </Grid>
                <Grid item xs={6} sm={3} md={1}>
                  <Button
                    className="btncancel"
                    variant="contained"
                    size="small"
                    ref={cancelRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        saveRef.current.focus();
                    }}
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={1}>
                  <Button
                    variant="contained"
                    size="small"
                    className="btnclear"
                    ref={clearRef}
                    onKeyDown={(e) => {
                      if (e.key.toLowerCase() === "home")
                        cancelRef.current.focus();
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Paper>
        ) : (
          ""
        )}
      </Box>

      <Box
        className="customerboxcontainer"
        sx={showFieldsContainer ? { mt: 3 } : { mt: 0 }}
      >
        <Paper elevation={2} sx={{ p: 2 }}>
          <TableContainer sx={{ maxHeight: 1000 }}>
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      hidden={column.id === "Id" ? true : false}
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {customersList.length > 0 ? (
                  customersList.map((customer) => (
                    <TableRow key={customer.Id}>
                      <TableCell>
                        <EditIcon
                          className="editicon"
                          fontSize="medium"
                          onClick={() => handleEdit(customer)}
                        />
                        <DeleteIcon
                          className="deleteicon"
                          fontSize="medium"
                          onClick={() => handleDelete(customer.Id)}
                        />
                      </TableCell>
                      <TableCell hidden={true}>{customer.Id}</TableCell>
                      <TableCell>{customer.CUCode}</TableCell>
                      <TableCell>{customer.CUName}</TableCell>
                      <TableCell>{customer.Place}</TableCell>
                      <TableCell>{customer.ContactNo}</TableCell>
                      <TableCell align="right">
                        {customer.OpeningBalance}
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No Customers found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            className="MuiTablePagination-selectLabel"
            rowsPerPageOptions={[10, 25, 50, 75, 100]}
            component="div"
            count={customersCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box>
    </>
  );
};

export default Customer;
